import { shallowEqual } from '@makeswift/controls'

export default shallowEqual
